(function() {
    'use strict';
    angular
        .module('josdaviApp')
        .factory('Langue', Langue);

    Langue.$inject = ['$resource'];

    function Langue ($resource) {
        var resourceUrl =  'api/langues/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
